import { AxiosResponse } from 'axios';
import { emperor } from '~/services';
import {
  CreateUniversalButtonBody,
  UniversalButton
} from '~/types/universalButton';

export const getAllActiveUniversalBtns = async (): Promise<
  AxiosResponse<UniversalButton[]>
> => {
  return await emperor.get('/universal-buttons');
};

export const deactivateUniversalBtn = async (uuid: string) => {
  return await emperor.put(`/universal-button/deactivate`, { uuid });
};

export const createUniversalBtn = async (button: CreateUniversalButtonBody) => {
  return await emperor.post('/universal-button', button);
};

export const updateUniversalBtn = async (button: CreateUniversalButtonBody) => {
  return await emperor.put(`/universal-button`, button);
};

export const getUniversalBtn = async (
  buttonId: string
): Promise<AxiosResponse<UniversalButton>> => {
  return await emperor.get(`/universal-button/${buttonId}`);
};
